// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable-next-line selector-class-pattern -- Класс консты */
.TreeCustomContextMenuc__customMenu___htQVN .ListItem_interactive:not(:focus).Text:hover {
    background: var(--color-control-bg-clear-hover);
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/ProjectObjects/TreeCustomContextMenu/TreeCustomContextMenuc.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;IACI,+CAA+C;AACnD","sourcesContent":["/* stylelint-disable-next-line selector-class-pattern -- Класс консты */\n.customMenu :global(.ListItem_interactive:not(:focus).Text):hover {\n    background: var(--color-control-bg-clear-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customMenu": `TreeCustomContextMenuc__customMenu___htQVN`
};
export default ___CSS_LOADER_EXPORT___;
